module.exports = __webpack_public_path__ + "img/nsw.01aff180.jpg";